export const acFreonTypeTypes = {
    loading: "LOADING_FREONTYPE",
    delete: "DELETE_FREONTYPE",
    loadedOne: "LOADED_FREONTYPE",
    loadedMultiple: "LOADED_FREONTYPES",
    success: "SUCCESS_FREONTYPE",
    restore: "RESTORE_FREONTYPE",
    hardDelete: "HARDDELETE_FREONTYPE",
};
